//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import React, { ReactElement, useEffect } from 'react'
import { Box, Typography, useTheme } from '@mui/material'
import Modal from '@mui/material/Modal'
import ButtonAction, { ButtonActionProps } from './elements/ButtonAction'
import Paper from '@mui/material/Paper'
import CloseIcon from '@mui/icons-material/Close'
import IconButton from '@mui/material/IconButton'

export const modalStyle = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 600,
  bgcolor: 'background.paper',
  borderRadius: '20px',
  boxShadow: '0px 16px 50px rgba(48, 49, 51, 0.08), 0px 0px 0.5px #303133',
  p: 5,
}

export interface ButtonModalProps extends Omit<ButtonActionProps, 'children'> {
  title: string
  children: ReactElement
  modalWidth?: number
  modalCloseCallback?: () => void
}

export default function ButtonModal(props: ButtonModalProps): ReactElement {
  const { variant, title } = props
  const [openModal, setOpenModal] = React.useState(false)
  const theme = useTheme()

  function callBack() {
    console.log('modalCloseCallback 2')
    if (props.modalCloseCallback) {
      console.log('modalCloseCallback 3')
      props.modalCloseCallback()
    }
  }
  useEffect(() => {
    window.addEventListener(
      'modalClose',
      () => {
        setOpenModal(false)
        callBack()
      },
      false
    )

    return () => {
      window.removeEventListener(
        'modalClose',
        () => {
          setOpenModal(false)
        },
        false
      )
    }
  }, [])

  const handleClose = (): void => {
    const event = new Event('modalClose')
    window.dispatchEvent(event)
  }
  const calculatedModalStyle = { ...modalStyle, width: props.modalWidth ?? 600 }
  return (
    <>
      <ButtonAction
        disabled={props.disabled ?? !!props.isAnotherRoleString}
        isAnotherRoleString={props.isAnotherRoleString}
        isLateString={props.isLateString}
        isEarlyString={props.isEarlyString}
        tooltip={props.tooltip}
        variant={variant}
        onClick={() => setOpenModal(true)}
      >
        {title}
      </ButtonAction>

      <Modal
        open={openModal}
        data-testid="modal"
        onClose={() => {
          setOpenModal(false)
          callBack()
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Paper sx={calculatedModalStyle}>
          <Typography
            align="left"
            sx={{ display: 'inline', float: 'left', fontWeight: 'bold', marginLeft: 4 }}
            variant={'h4'}
          >
            {title}{' '}
          </Typography>
          <IconButton
            onClick={handleClose}
            sx={{ height: '14px', width: '14px', padding: 0, float: 'right', color: theme.palette.primary.main }}
          >
            <CloseIcon sx={{ width: '12px', height: '12px', marginTop: 0, color: theme.palette.fg.muted }} />
          </IconButton>
          <Box sx={{ marginTop: '32px', marginLeft: 2 }}>{props.children}</Box>
        </Paper>
      </Modal>
    </>
  )
}
